import makeStyles from '@mui/styles/makeStyles';

const styles = (theme) => ({

  footer: () => {
    return  {
        position: 'absolute',
        display: 'flex',
        width: '100%',
        height: '40px',
        justifyContent: 'center',
        alignItems: 'center',

        left: '0px',
        bottom: '0px',
        backgroundColor: '#DFE4E7',
    };
  },

  powered: () => {
    return  {
       display: 'flex',
       height: '100%',

       justifyContent: 'space-between',
       alignItems: 'center',

       '& img': {
          height: '21px',
          width: 'auto',
          maxWidth: '150px',
          border: 'none',
          outline: 'none',
          marginBottom: '-3px',
       }
    };
  },

});

export default styles;
export const useStyles = makeStyles(styles);
